<div class="hide-acc">
    <div class="container-box">
        <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb> -->
        <div class="row">
            <div class="col-sm-12 col-md-6 col-md-offset-3 product-manage " *ngIf="singleUserDetail !== null">

                <h1>{{this.singleUserDetail && this.singleUserDetail.specName}}</h1>
                <div *ngIf="reviewComponentSuccessMessageFlag">
                    <div class="alert valign-children-middle" *ngIf="errorMessage">
                        <div class="alert-error" aria-label="Alert.">
                            <i class="icon-badgealert" aria-hidden="true"></i>
                        </div>
                        <div>
                            <h2>Something isn't working</h2>
                            <p>{{ this.errorMessage }}</p>
                        </div>
                    </div>
                    <div *ngIf="reviewComponentSuccessMessage">
                        <div class="alert valign-children-middle">
                            <div class="alert-success">
                                <i class="icon-approval" aria-hidden="true"></i>
                            </div>
                            <div>
                                <h2>Success</h2>
                                <p>{{reviewComponentSuccessMessage}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <section>
                    <div><strong>Foundation account:</strong><span> {{fan}}</span></div>
                    <div><strong>Wireless number:</strong><span> {{ctn}}</span></div>
                    <div *ngIf="singleUserDetail.productDesc == null"><strong>License group:</strong><a href="javascript:void(0)" aria-label="Assign a name - opens a dialog box" (click)="assignName()"> Assign a name</a></div>
                    <div *ngIf=" singleUserDetail.productDesc && singleUserDetail.productDesc.length!=0"><strong>{{singleUserDetail.productDesc}}</strong><a href="javascript:void(0)" aria-label="Edit - opens a dialog box" (click)="editName()"> Edit </a></div>
                </section>

                <app-usage-bar [totalValue]="totalLicenses" [dynamicValue]="licensesAssigned" [leftText]="leftLabel" [rightText]="rightLabel">
                </app-usage-bar>
                <div class="pull-right license-status" *ngIf = "!singleQuantityInfo" ><strong>Number of Licenses: </strong>
                    <div class="status">
                        <a href="javascript:void(0)" class="seperator"(click)="modifyLicense('Increase')">Add</a>
                        <a href="javascript:void(0)" class="seperator" (click)="modifyLicense('Decrease')">Remove</a>
                        <a routerLink="./cancel-product" href="javascript:void(0)">Remove all</a></div>
                </div>
                <div class="clearfix"></div>
                <div class="row create-assign" *ngIf = "singleQuantityInfo">
                    <div class="col-md-3 col-sm-6" *hasPermission="createUser"><a routerLink="/user/add" class="create-user"><i class="icon-people-onepersonL" aria-hidden="true"></i> Create user</a></div>
                    <div class="col-md-3 col-sm-6 text-center" *hasPermission="assignUnassign">
                        <a href="javascript:void(0)" (click)="assignUnassignWizard()" class="assign-unassign"><i class=" icon-people-usercheckL" aria-hidden="true"></i>Assign or un-assign user licenses</a>
                    </div>
                    <div class="col-md-3 col-sm-6 text-right change-prod" *hasPermission="changeProduct"><a href="javascript:void(0)" routerLink="/changeProduct" class="change-product"><i class="icon-arrows-replay-restartL" aria-hidden="true"></i>Change product</a></div>
 					<div class="col-md-3 col-sm-6  text-center change-prod"  ><a routerLink="./cancel-product"  href="javascript:void(0)" class="change-product"><i class="icon-controls-statusokayL white" aria-hidden="true"></i>Remove product</a></div>
				</div>
				<div class="row create-assign" *ngIf = "!singleQuantityInfo">
                    <div class="col-md-3 col-sm-6" *hasPermission="createUser"><a routerLink="/user/add" class="create-user"><i class="icon-people-onepersonL" aria-hidden="true"></i> Create user</a></div>
                    <div class="col-md-6 col-sm-6 text-center" *hasPermission="assignUnassign">
                        <a href="javascript:void(0)" (click)="assignUnassignWizard()" class="assign-unassign"><i class=" icon-people-usercheckL" aria-hidden="true"></i>Assign or un-assign user licenses</a>
                    </div>
                    <div class="col-md-3 col-sm-6 text-right change-prod" *hasPermission="changeProduct"><a href="javascript:void(0)" routerLink="/changeProduct" class="change-product"><i class="icon-arrows-replay-restartL" aria-hidden="true"></i>Change product</a></div> 					
				</div>
                <div class="clearfix"></div>
                <hr>
                <h2>Licensed users</h2>

                <app-customgrid [gridOptions]="gridOptions" (gridEvent)="gridEventChanges($event)" (hrefLink)="linkActivated($event,focusable);"></app-customgrid>

            </div>
        </div>
    </div>

    <app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>
</div>

<!--License group name popup -->
<app-modal [showModal]="popUpFlag" [modalCoverClass]="modalCoverClass" [modalClass]="modalClass">
    {{UloadFocustelements()}}
    <form [formGroup]="licenseForm" (keydown)="UhandleKeydown($event)">
        <div #assignGroup>
            <header class="popup-header">
                <h2 id='modalHeader' tabindex="0" *ngIf="assignProductFlag">Assign a name</h2>
                <h2 id='modalHeader' tabindex="0" *ngIf="editNameFlag">Change license group name</h2>
            </header>
            <div class="corner-button">
                <button type="button" class="close" aria-label="Close" (click)="cancelButton($event)" tabindex="0">x</button>
            </div>
            <div class="popup-body">
                <h2>{{this.singleUserDetail.specName}}</h2>
                <hr/>
                <div><strong>Foundation account: </strong>{{singleUserDetail.brokerAccountClientId}}</div>
                <p><strong>Wireless number: </strong>{{singleUserDetail.billingClientId}}</p>
                <div class="row assign-prod" *ngIf="assignProductFlag">
                    <label for="worforce" class="col-md-12">Enter a license group name (optional)</label>
                    <label class="col-md-12">(Example: Marketing team)</label>
                </div>
                <div *ngIf="editNameFlag">
                    <div class="current-prod"><strong>Current license group name: </strong><span>{{singleUserDetail.productDesc}}</span></div>
                    <div class="form-group">
                        <label for="newname" class="col-sm-12 col-md-12" [ngClass]="{'error-field': formErrors.productName}">New license group name</label>
                    </div>
                </div>
                <label for="workforce"><div class="hide-element">workforce</div></label>
                <div class="col-md-6 col-sm-12  input-text"><input [attr.aria-describedby]="formErrors.productName ? 'license-name' : null" formControlName="productName"
                        class="form-control" maxlength="40" type="text" id="workforce" [class.text-error]="formErrors.productName"></div>
                <div id="license-name" class="text-danger" *ngIf="formErrors.productName">
                    {{formErrors.productName}}
                </div>

            </div>
            <div class="clearfix"></div>
            <div class="text-right popup-footer">
                <hr/>
                <button class="btn btn-secondary btn-click text-center" [checkImpersonator]="!licenseForm.valid || csrPermissionUnassignPopButton"
                    (click)="assignButton($event)">Assign</button>
                <a href="javascript:void(0)" class="btn btn-link text-center" (click)="cancelButton($event)">Cancel</a>
            </div>
        </div>
    </form>
</app-modal>

<!--Unassign license popup -->
<app-modal [showModal]="unAssignPopup" [modalClass]="modalClass">
    {{loadFocustelements()}}
    <div #unAssign (keydown)="handleKeydown($event)">
        <div class="modal-header">
            <h2 id='modalHeader' tabindex="0">Un-assign a user</h2>
        </div>
        <div class="corner-button">
            <button type="button" #focusable class="close" aria-label="Close" (click)="cancel($event)">x</button>
        </div>
        <div class="modal-body break-text">
            <div class="unassign-user"><strong>Selected user</strong>
                <div>{{rowUser && rowUser.firstName}}</div>
                <div>{{rowUser && rowUser.email}}</div>
            </div>
            <div><strong>Un-assign this user's license for:</strong>
                <div>{{singleUserDetail.specName}} </div>
                <div><strong>Foundation account:</strong> {{fan}}</div>
                <div><strong>Wireless number:</strong> {{ctn}}</div>
                <div *ngIf=" singleUserDetail.productDesc && singleUserDetail.productDesc.length!=0"> <strong>{{singleUserDetail.productDesc}}</strong> </div>
            </div>
        </div>
        <div class="col-sm-12 modal-footer">
            <hr/>
            <button (click)="updateUnAssignDetails($event)" [checkImpersonator]='csrPermissionUnassignPopButton' class="btn btn-secondary logInTest pull-right">Un-assign</button>
            <!--<a href="javascript:void(0)" class="btn btn-link btn-cart pull-right" (click)="updateUnAssignDetails($event)">Unassign</a>
        --><a class="btn btn-link btn-cart pull-right" href="javascript:void(0)" (click)="cancel($event)">Cancel</a>
        </div>
    </div>
</app-modal>
